export default "__VITE_ASSET__D7_oAu_S__"